import Phaser from "phaser";
import { FishBase } from "./FishBase";

export class PikeAI extends FishBase {
    private movementState: "pause" | "dart" = "pause";
    private stateUntil = 0;
    private direction = new Phaser.Math.Vector2(1, 0);

    constructor(scene: Phaser.Scene, x: number, y: number) {
        super(scene, x, y, {
            species: "Northern Pike",
            textureKey: "northern-pike",
            pointValue: 30,
            swimSpeed: 170,
        });
    }

    override update(time: number): void {
        if (time >= this.stateUntil) {
            if (this.movementState === "pause") {
                this.movementState = "dart";
                this.direction = new Phaser.Math.Vector2(Phaser.Math.FloatBetween(-1, 1), Phaser.Math.FloatBetween(-1, 1)).normalize();
                this.stateUntil = time + Phaser.Math.Between(600, 900);
            } else {
                this.movementState = "pause";
                this.stateUntil = time + Phaser.Math.Between(1000, 3000);
            }
        }

        if (this.movementState === "pause") {
            this.setVelocity(0, 0);
        } else {
            const vx = this.direction.x * this.swimSpeed;
            const vy = this.direction.y * this.swimSpeed;
            this.swimWithBias(vx, vy);
            this.direction.setToPolar(this.rotation, 1);
        }
    }
}
